module.exports = __webpack_public_path__ + "static/media/slideimage-3.dd87b80f.jpg";